<cec-dialog
  [headerText]="headerText()"
  [headerKey]="headerKey()"
  [subTitle]="subTitle()"
  [width]="width()" 
  [hideConfirmButton]="!isOrganizer"
  (onButtonClicked)="onClickButton($event)">
  @switch (type) {
    @case ('message') {
      @if (isOrganizer && textAreaLabelKey) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ textAreaLabelKey | translate }}</mat-label>
          <textarea matInput [(ngModel)]="message"></textarea>
        </mat-form-field>
      } @else {
        <div class="message">
          {{ message }}
        </div>
      }
    }
    @case ('list') {
      @for (value of values; track value) {
        <li> {{ value }}</li>
      }
    }
    @case ('custom') {
      <ng-content></ng-content>
    }
  }
</cec-dialog>
